export const TIMER_MINUTES = 2;

export const UNIT_OF_MEASURES = [
    {nm:"Meters", value:"Meters"},
    {nm:"Pouch", value:"Pouch"},
    {nm:"Grams", value:"Grams"},
    {nm:"Litres", value:"Litres"},
    {nm:"Millilitres", value:"Millilitres"},
    {nm:"Set", value:"Set"},
    {nm:"Kilograms", value:"Kilograms"},
    {nm:"Count", value:"Count"}
];

export const DELIVERY_OBJ={
    'ORDER_PLACED':"Order Placed",
    'ORDER_ACCEPTED':"Order Accepted",
    'ORDER_READY_FOR_PICKUP':"Ready for pickup",
    'ORDER_PICKED':"Order Picked",
    'ORDER_TRANSIST':"In Transist",
    'ORDER_OUT_DELIVERY':"Out For Delivery",
    'ORDER_DELIVERED':"Delivered",
    'ORDER_CANCELLED':"Cancelled",
    'ORDER_REJECTED':"Rejected",
    'ORDER_RETURN_INITIATED':"Return Initiated",
    'ORDER_RETURN_PROCESSED':"Return processed"
}

export const DELIVERY_OPTIONS = [
    'ORDER_PLACED',
    'ORDER_ACCEPTED',
    'ORDER_READY_FOR_PICKUP',
    'ORDER_PICKED',
    'ORDER_TRANSIST',
    'ORDER_OUT_DELIVERY',
    'ORDER_DELIVERED',
    'ORDER_CANCELLED',
    'ORDER_REJECTED',
    'ORDER_RETURN_INITIATED',
    'ORDER_RETURN_PROCESSED'
]